export default __webpack_public_path__ + "static/media/fiberhome.b4facf11.png";